import React from 'react';
import useNextStepVm from '|/app/purchase/flow/next-step/use-next-step-vm';
import { Dashboard, Summary, AvailableOptions } from '|/app/services';

const defaultProps = {
  setDashboard: (_: Dashboard) => {
    /* intentionally left blank */
  },
  setSummary: (_: Summary) => {
    /* intentionally left blank */
  },
  setAvailableOptions: (_: AvailableOptions) => {
    /* intentionally left blank */
  }
};

const NextStep = ({ setDashboard, setSummary, setAvailableOptions } = defaultProps) => {
  useNextStepVm(setDashboard, setSummary, setAvailableOptions);
  return <></>;
};

export default NextStep;
